<template>
  <div id="forecast-counties-root">
    <v-row no-gutters class="title-row">
      <v-col cols="12" class="pa-4 d-flex align-center">
        <div class="d-flex flex-column">
          <div class="d-flex align-center">
            <span class="forecast-counties-title"
              >Previsão de consumidores interrompidos para os municípios</span
            >
          </div>
          <div>
            <span class="forecast-counties-subtitle"
              >Previsão meteorológica e de interrupções para
              {{ moment().add(1, "days").format("DD/MM/YYYY") }}.</span
            >
          </div>
        </div>
        <v-spacer></v-spacer>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="table-row" no-gutters>
      <v-col
        cols="12"
        class="pt-4 px-4 d-flex align-center justify-space-between"
      >
        <div class="form-input-group">
          <v-text-field
            v-model="searchCountie"
            class="text-field"
            id="search"
            placeholder="Informe o município"
            outlined
            color="accent lighten-1"
            background-color="secondary"
            required
            dense
          >
          </v-text-field>
          <label for="search">Informe o município</label>
        </div>
        <div class="form-input-group">
          <v-autocomplete
            class="text-field"
            id="regional"
            color="accent lighten-1"
            background-color="secondary"
            v-model="regionalSelected"
            outlined
            required
            dense
            placeholder="Informe as regionais"
            :items="regionalsList"
            item-text="fullname"
            item-value="id"
            return-object
            multiple
            append-icon="icon-alertadis-angle-down"
            :menu-props="{ rounded: 'lg', maxHeight: 400 }"
          >
            <template v-slot:prepend-item="">
              <v-list-item class="py-2" ripple @click.stop="selectAllRegional"
                ><div class="d-flex align-center">
                  <v-simple-checkbox
                    color="accent"
                    :value="regionalSelected.length == regionalsList.length"
                    @click.stop="selectAllRegional"
                  />
                  <span
                    class="dropdown-item-style"
                    :style="
                      regionalSelected.length == regionalsList.length
                        ? 'color: var(--v-accent-base)'
                        : ''
                    "
                  >
                    Todos
                  </span>
                </div>
              </v-list-item>
            </template>
            <template #item="{ item }">
              <v-list-item
                class="py-2"
                ripple
                @click.stop="toggleRegionalItem(item)"
              >
                <div class="d-flex align-center">
                  <v-simple-checkbox
                    color="accent"
                    :value="isSelectedRegional(item)"
                    @click.stop="toggleRegionalItem(item)"
                  />
                  <span
                    class="dropdown-item-style"
                    :style="
                      isSelectedRegional(item)
                        ? 'color: var(--v-accent-base)'
                        : ''
                    "
                  >
                    {{ item.fullname }}
                  </span>
                </div>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item, index }">
              <div v-if="regionalSelected.length == regionalsList.length">
                <div
                  v-if="index === 0"
                  class="shutdown-risk-chip d-flex align-center"
                >
                  <span>Todas</span>
                </div>
              </div>
              <div v-else>
                <div v-if="index === 0" class="shutdown-risk-chip">
                  <span>{{ item.fullname }}</span>
                  <v-btn
                    v-if="regionalSelected.length > 1"
                    @click="removeRegional(item)"
                    x-small
                    icon
                    ><v-icon size="16" color="primary"
                      >icon-alertadis-times-circle</v-icon
                    ></v-btn
                  >
                </div>
                <div v-if="index === 1" class="ml-1 shutdown-risk-chip">
                  <span>+{{ regionalSelected.length - 1 }}</span>
                </div>
              </div>
            </template>
          </v-autocomplete>
          <label for="regional">Regionais</label>
        </div>
        <div class="form-input-group">
          <v-select
            class="text-field"
            id="agency"
            color="accent lighten-1"
            background-color="secondary"
            v-model="agencySelected"
            outlined
            required
            dense
            placeholder="Informe as agências"
            :items="agenciesListItems"
            item-text="name"
            item-value="id"
            return-object
            multiple
            append-icon="icon-alertadis-angle-down"
            :menu-props="{ rounded: 'lg', maxHeight: 400, maxWidth: 260 }"
          >
            <template v-slot:prepend-item="">
              <v-list-item
                v-show="agenciesListItems.length > 0"
                class="py-2"
                ripple
                @click.stop="selectAllAgency"
                ><div class="d-flex align-center">
                  <v-simple-checkbox
                    color="accent"
                    :value="agencySelected.length == agenciesListItems.length"
                    @click.stop="selectAllAgency"
                  />
                  <span
                    class="dropdown-item-style"
                    :style="
                      agencySelected.length == agenciesListItems.length
                        ? 'color: var(--v-accent-base)'
                        : ''
                    "
                  >
                    Todos
                  </span>
                </div>
              </v-list-item>
            </template>
            <template #item="{ item }">
              <v-list-item
                class="py-2"
                ripple
                @click.stop="toggleItemAgency(item)"
              >
                <div class="d-flex align-center">
                  <v-simple-checkbox
                    color="accent"
                    :value="isSelectedAgency(item)"
                    @click.stop="toggleItemAgency(item)"
                  />
                  <div
                    class="d-flex align-center dropdown-item-style"
                    :style="
                      isSelectedAgency(item)
                        ? 'color: var(--v-accent-base)'
                        : ''
                    "
                  >
                    <span>{{ item.id }} {{ item.name }}</span>
                  </div>
                </div>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item, index }">
              <div v-if="agencySelected.length == agenciesListItems.length">
                <div
                  v-if="index === 0"
                  class="shutdown-risk-chip d-flex align-center"
                >
                  <span>Todas</span>
                </div>
              </div>
              <div v-else>
                <div
                  v-if="index === 0"
                  class="shutdown-risk-chip d-flex align-center"
                >
                  <span
                    >{{ item.id }} {{ capitalizeFirstLetter(item.name) }}</span
                  ><v-btn
                    v-if="agencySelected.length > 1"
                    @click="removeAgency(item)"
                    x-small
                    icon
                    ><v-icon size="16" color="primary"
                      >icon-alertadis-times-circle</v-icon
                    ></v-btn
                  >
                </div>
                <div v-if="index === 1" class="ml-1 shutdown-risk-chip">
                  <span>+{{ agencySelected.length - 1 }}</span>
                </div>
              </div>
            </template>
          </v-select>
          <label for="agency">Base de Serviço de Campo</label>
        </div>
        <v-btn
          @click="resetFilter"
          height="40"
          class="mb-2 btn-form"
          color="accent"
          outlined
          ><v-icon size="14">mdi-reload</v-icon>Restaurar filtros</v-btn
        >
      </v-col>
    </v-row>
    <v-row class="table-row" no-gutters>
      <v-col cols="12" class="px-4 pb-2">
        <v-data-table
          ref="datatablePrediction"
          id="predictionDataTable"
          class="prediction-data-table"
          height="48vh"
          :headers="shutdownRiskTableHeader"
          :loading="countiesForecastTableDetailsDataLoading"
          :items="countiesForecastTableDetails"
          :options.sync="pagination"
          fixed-header
          hide-default-footer
          item-key="id"
          show-expand
          group-by="agency"
          :header-props="{
            'sort-icon': 'icon-alertadis-angle-up',
          }"
          @item-expanded="onExpand"
        >
          <template v-slot:[`group.header`]="{ group, headers, items }">
            <td class="td-header-agency"></td>
            <td class="py-2 td-header-agency">
              <div class="d-flex flex-column">
                <div class="header-agency-text">
                  {{ group }}
                  {{ items[0].agencyName }}
                </div>
                <div>
                  <span class="header-agency-counties">{{ items.length }}</span>
                  <span class="header-agency-counties-name"> municípios </span>
                </div>
              </div>
            </td>
            <td class="td-header-agency">
              <div :id="`progress-${group}`"></div>
              {{ createAlertBar(items, `progress-${group}`) }}
            </td>
            <td :colspan="headers.length - 3" class="td-header-agency"></td>
          </template>
          <template v-slot:[`item.data-table-expand`]="{ expand, isExpanded }">
            <v-icon color="accent" @click="expand(!isExpanded)">
              {{ !isExpanded ? "mdi-chevron-down" : "mdi-chevron-up" }}</v-icon
            >
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td
              :colspan="headers.length"
              style="background: var(--v-secondary-base)"
            >
              <v-row no-gutters>
                <v-col v-show="countiesForecastDataLoading" cols="12">
                  <lottie
                    class="loading-animation"
                    :options="alertaDisLoadingStationData"
                    :height="370"
                    :width="100"
                  />
                </v-col>
                <v-col
                  v-show="!countiesForecastDataLoading"
                  cols="12"
                  class="color-prev pt-2"
                >
                  <div id="content" class="pb-5 d-flex align-center">
                    <div id="content-title">
                      <span id="title-chart">
                        <i class="icon-alertadis-lightbulb-off-outline"></i>
                        Previsão de Consumidor Interrompido em
                        {{ item.locationName }}
                      </span>
                      <p id="subtitle-chart" class="pl-2">
                        Previsão meteorológica e de interrupções no período de
                        {{moment().format("DD/MM/YYYY"),}} até
                        {{moment().add(4, "days").format("DD/MM/YYYY"),}}
                      </p>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="pt-4">
                      <span class="pl-2">
                        <v-btn
                          max-height="32"
                          min-height="32"
                          max-width="32"
                          min-width="32"
                          class="btn-style"
                          :color="
                            changeBackgroundColorWind ? '#F5821E' : '#151723'
                          "
                          @click="toggleWind"
                          :style="
                            changeBackgroundColorWind
                              ? ''
                              : 'border: 1px solid #F2F2F8;'
                          "
                        >
                          <v-icon
                            small
                            :color="
                              changeBackgroundColorWind ? '#151723' : '#F99741'
                            "
                            >icon-alertadis-wind</v-icon
                          >
                        </v-btn>
                      </span>
                      <span class="pl-2">
                        <v-btn
                          max-height="32"
                          min-height="32"
                          max-width="32"
                          min-width="32"
                          class="btn-style"
                          :color="
                            changeBackgroundColorRain ? '#F5821E' : '#151723'
                          "
                          @click="toggleRain"
                          :style="
                            changeBackgroundColorRain
                              ? ''
                              : 'border: 1px solid #F2F2F8;'
                          "
                        >
                          <v-icon
                            :color="
                              changeBackgroundColorRain ? '#151723' : '#F99741'
                            "
                            >icon-alertadis-wi-rain</v-icon
                          >
                        </v-btn>
                      </span>
                      <span class="pl-2">
                        <v-btn
                          max-height="32"
                          min-height="32"
                          max-width="32"
                          min-width="32"
                          class="btn-style"
                          :style="
                            changeBackgroundColorTemperature
                              ? ''
                              : 'border: 1px solid #F2F2F8;'
                          "
                          :color="
                            changeBackgroundColorTemperature
                              ? '#F5821E'
                              : '#151723'
                          "
                          @click="toggleTemperature"
                        >
                          <v-icon
                            small
                            :color="
                              changeBackgroundColorTemperature
                                ? '#151723'
                                : '#F99741'
                            "
                            >icon-alertadis-temperature-three-quarter</v-icon
                          >
                        </v-btn>
                      </span>
                      <v-btn class="ml-4" icon small @click="fullscreenChart">
                        <v-icon color="#F99741"> mdi-fullscreen</v-icon>
                      </v-btn>

                      <v-menu left offset-y min-width="100">
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" icon>
                            <v-icon color="#F99741" small>$export</v-icon>
                          </v-btn>
                        </template>

                        <v-list class="py-4" dense>
                          <v-list-item @click="printChart()">
                            <span class="font-size-style"
                              >Imprimir gráfico</span
                            >
                          </v-list-item>
                          <v-list-item link @click="exportChart('image/png')">
                            <v-list-item-content>
                              <span class="font-size-style"
                                >Baixar imagem PNG</span
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item link @click="exportChart('image/jpeg')">
                            <v-list-item-content>
                              <span class="font-size-style"
                                >Baixar imagem JPEG</span
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item
                            link
                            @click="exportChart('image/svg+xml')"
                          >
                            <v-list-item-content>
                              <span class="font-size-style"
                                >Baixar imagem SVG</span
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item
                            link
                            @click="exportChart('application/pdf')"
                          >
                            <v-list-item-content>
                              <span class="font-size-style"
                                >Baixar documento PDF</span
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item link @click="exportCSV">
                            <v-list-item-content>
                              <span class="font-size-style"
                                >Baixar documento CSV</span
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item link @click="exportXLS">
                            <v-list-item-content>
                              <span class="font-size-style"
                                >Baixar documento XLS</span
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </div>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <div
                        :id="`chart-container-${item.locationId}`"
                        class="d-flex justify-center align-center"
                      ></div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </td>
          </template>
          <template v-slot:[`item.locationName`]="{ item }">
            <div class="d-flex flex-column">
              <div>
                <span class="countie-column">{{ item.locationName }}</span>
              </div>
              <div class="d-flex">
                <div class="pa-1 countie-sig">{{ item.regional }}</div>
                <div class="ml-1 pa-1 countie-sig">{{ item.agency }}</div>
              </div>
            </div>
          </template>
          <template v-slot:[`item.ciRange`]="{ item }">
            <div>
              <div
                class="pa-4 d-flex flex-column"
                :style="`color: ${backgroundCiColor(item.ciRange)}`"
                style="position: relative; height: 70px"
              >
                <span class="ci-title">
                  {{ item.ci }}
                </span>
              </div>
              <div
                style="position: relative; margin-top: -70px; height: 70px"
                :style="backgroundCiColorBg(item.ciRange)"
              ></div>
            </div>
          </template>
          <template v-slot:[`item.windGust`]="{ item }">
            <div class="pa-4 d-flex align-center justify-start">
              <div class="d-flex flex-column align-start">
                <span
                  class="ci-range"
                  :style="`color: ${alertsWindColor(item.windGust)}`"
                >
                  {{ item.windGust }} km
                </span>
              </div>
            </div>
          </template>

          <template v-slot:[`item.precIntensity`]="{ item }">
            <div
              v-if="$locationFilter.period.id < 5"
              class="pa-4 d-flex align-center justify-start"
            >
              <div
                class="d-flex flex-column align-start"
                :style="`color: ${alertsPreciColor(item.precIntensity)}`"
              >
                <span class="ci-range"> {{ item.precIntensity }} mm </span>
              </div>
            </div>
            <div v-else class="pa-4 d-flex align-center justify-start">
              <div
                class="d-flex flex-column align-start"
                :style="`color: ${alertsPreciColorDiary(item.precIntensity)}`"
              >
                <span class="ci-range"> {{ item.precIntensity }} mm </span>
              </div>
            </div>
          </template>

          <template v-slot:[`item.temp`]="{ item }">
            <div
              v-if="$locationFilter.period.id < 5"
              class="pa-4 d-flex align-center justify-start"
            >
              <div class="d-flex align-center">
                <span
                  class="ci-range"
                  :style="`color: ${alertsTempColor(item.temp)}`"
                >
                  {{ item.temp }} ºC
                </span>
              </div>
            </div>
            <div v-else class="pa-4 d-flex align-center justify-start">
              <div class="d-flex align-center">
                <span
                  class="ci-range"
                  :style="`color: ${alertsTempColor(item.tempMin)}`"
                >
                  {{ item.tempMin }} ºC
                </span>
                <span class="px-1" style="color: var(--v-secondary-lighten3)"
                  >|</span
                >
                <span
                  class="ci-range"
                  :style="`color: ${alertsTempColor(item.tempMax)}`"
                >
                  {{ item.tempMax }} ºC
                </span>
              </div>
            </div>
          </template>
          <template v-slot:footer="{ props }">
            <v-divider></v-divider>
            <div class="py-2 d-flex align-center table-footer">
              <span class="pl-4 pagination-counter">
                mostrando
                {{
                  props.pagination.itemsPerPage * props.pagination.page +
                  1 -
                  props.pagination.itemsPerPage
                }}
                -
                {{
                  props.pagination.itemsPerPage * props.pagination.page >
                  props.pagination.itemsLength
                    ? props.pagination.itemsLength
                    : props.pagination.itemsPerPage * props.pagination.page
                }}
                de {{ props.pagination.itemsLength }} resultados
              </span>
              <v-spacer></v-spacer>
              <span class="pagination-counter"> resultados por página: </span>
              <div class="ml-2">
                <v-select
                  class="select-pagination"
                  dense
                  hide-details
                  :value="props.pagination.itemsPerPage"
                  @change="pagination.itemsPerPage = parseInt($event, 10)"
                  :items="[10, 20, 30]"
                  append-icon="icon-alertadis-angle-down"
                >
                  <template v-slot:selection="{ item }">
                    <div class="pagination-counter">{{ item }}</div>
                  </template>
                </v-select>
              </div>
              <v-pagination
                color="accent"
                v-model="pagination.page"
                :length="tablePages(props.pagination.itemsLength)"
                :total-visible="5"
              ></v-pagination>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-card>
      <v-card-actions>
        <v-btn
          @click="closeForecastTableDialog"
          height="40"
          class="my-4 btn-form"
          color="accent"
          outlined
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import moment from "moment";
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";
import offlineExporting from "highcharts/modules/offline-exporting";
import accessibility from "highcharts/modules/accessibility";
exportingInit(Highcharts);
offlineExporting(Highcharts);
accessibility(Highcharts);
require("highcharts/modules/export-data")(Highcharts);
import Lottie from "@/core/component/lottie.vue";
import alertaDisLoadingLottie from "@/assets/loadingAlertaDisAnimation.json";

export default {
  components: {
    Lottie,
  },
  props: {
    filter: {
      type: [Object, String],
      required: true,
    },
    nameCountie: {
      type: String,
      required: true,
    },
    openedDialog: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    searchCountie: "",
    searchCountieTemp: "",
    regionalSelected: [],
    agencySelected: [],
    countiesSelected: [],
    pagination: {
      page: 1,
      itemsPerPage: 10,
    },
    cIAlertChart: null,
    period: [],
    changeBackgroundColorTemperature: false,
    changeBackgroundColorWind: true,
    changeBackgroundColorRain: true,
    formatting: null,
    daysOfWeek: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    coutiesSelected: [],
    seriesTemperature: [],
    seriesWind: [],
    seriesPrecIntencity: [],
    seriesTempMin: [],
    seriesTempMax: [],
    seriesTemp: [],
    seriesCis: [],
    seriesTempMinHours: [],
    seriesWindHours: [],
    seriesPrecIntencityHours: [],
    seriesTempMaxHours: [],
    seriesTempHours: [],
    seriesCisHours: [],
    alertaDisLoadingStationData: {
      animationData: alertaDisLoadingLottie,
    },
  }),
  mounted() {
    this.mountedFilterSelected();
  },
  watch: {
    openedDialog() {
    },
    filter: {
      handler: function (newVal) {
        //Testa se é uma regional
        if (newVal.regional) {
          const val = this.regionalsList.filter(
            (el) => el.fullname == newVal.regional
          );
          if (val) {
            this.regionalSelected = val;
          }
        }
        //Testa se é uma agencia
        if (newVal.regionalByAgency) {
          const val = this.regionalsList.filter(
            (el) => el.name == newVal.regionalByAgency
          );
          if (val) {
            this.regionalSelected = val;
            const val2 = this.agenciesList.filter(
              (el) => el.id == newVal.agency
            );
            if (val2) {
              this.$nextTick(() => {
                this.agencySelected = val2;
              });
            }
          }
        }
        //Testa se é um município
        if (newVal.regionalByAgencyByCity) {
          const val = this.regionalsList.filter(
            (el) => el.name == newVal.regionalByAgencyByCity
          );
          if (val) {
            this.regionalSelected = val;
            const val2 = this.agenciesList.filter(
              (el) => el.id == newVal.agency
            );
            if (val2) {
              this.$nextTick(() => {
                this.agencySelected = val2;
              });
            }
          }
        }
        this.pagination.page = 1;
      },
      deep: true,
      immediate: false,
    },
    nameCountie: {
      handler: function (newVal) {
        this.searchCountie = newVal;
        this.searchCountieTemp = newVal;
      },
      deep: true,
      immediate: true,
    },
    regionalSelected() {
      this.agencySelected = [...this.agenciesListItems];
    },
    agencySelected: {
      handler: _.debounce(function () {
        this.fetchConsumerTableData();
      }, 1000),
      deep: true,
      immediate: false,
    },
    "pagination.page"() {
      this.closeExpandAll();
    },
  },
  computed: {
    ...mapGetters([
      "regionalsList",
      "agenciesList",
      "countiesList",
      "countiesForecastTableDetails",
      "countiesForecastTableDetailsDataLoading",
      "countiesForecastDataAll",
      "countiesForecastDataHourlyAll",
      "countiesForecastDataLoading",
    ]),
    agenciesListItems() {
      return this.agenciesList.filter((a) =>
        this.regionalSelected.map((b) => b.name).includes(a.regional)
      );
    },
    countiesSelectedItems() {
      return this.countiesList.filter((a) =>
        this.agencySelected
          .map((b) => b.id)
          .includes(a.agencies ? a.agencies[0] : "")
      );
    },
    shutdownRiskTableHeader() {
      return [
        {
          text: "Municípios",
          sortable: true,
          value: "locationName",
          class: "secondary",
          filter: this.filterCountie,
        },
        {
          text: "Previsão de consumidores interrompidos",
          sortable: true,
          value: "ciRange",
          class: "secondary",
        },
        {
          text: "Rajada máxima de vento",
          sortable: true,
          value: "windGust",
          class: "secondary",
        },
        {
          text: "Precipitação",
          sortable: true,
          value: "precIntensity",
          class: "secondary",
        },
        {
          text: "Temperatura",
          sortable: true,
          value: "temp",
          class: "secondary",
        },
      ];
    },
  },
  methods: {
    tablePages(totalResults) {
      if (totalResults <= 0) {
        return 0;
      }
      return Math.ceil(
        totalResults / this.pagination.itemsPerPage
      );
    },
    mountedFilterSelected() {
      //Testa se é uma regional
      if (this.filter.regional) {
        const val = this.regionalsList.filter(
          (el) => el.fullname == this.filter.regional
        );
        if (val) {
          this.regionalSelected = val;
        }
      }
      //Testa se é uma agencia
      if (this.filter.regionalByAgency) {
        const val = this.regionalsList.filter(
          (el) => el.name == this.filter.regionalByAgency
        );
        if (val) {
          this.regionalSelected = val;
          const val2 = this.agenciesList.filter(
            (el) => el.id == this.filter.agency
          );
          if (val2) {
            this.$nextTick(() => {
              this.agencySelected = val2;
            });
          }
        }
      }
      //Testa se é um município
      if (this.filter.regionalByAgencyByCity) {
        const val = this.regionalsList.filter(
          (el) => el.name == this.filter.regionalByAgencyByCity
        );
        if (val) {
          this.regionalSelected = val;
          const val2 = this.agenciesList.filter(
            (el) => el.id == this.filter.agency
          );
          if (val2) {
            this.$nextTick(() => {
              this.agencySelected = val2;
              if (this.nameCountie) {
                this.searchCountie = this.searchCountieTemp;
              }
            });
          }
        }
      }
    },
    capitalizeFirstLetter(string) {
      let word = string.charAt(0).toUpperCase() + string.slice(1);
      if (word.length > 17) {
        word = word.substring(0, 12) + "...";
      }
      return word;
    },
    resetFilter() {
      this.mountedFilterSelected();
    },
    selectAllRegional() {
      if (this.regionalSelected.length <= 0) {
        return this.regionalsList.forEach((el) =>
          this.regionalSelected.push(el)
        );
      }
      this.regionalsList.forEach((el) => {
        if (!this.regionalSelected.some((elSel) => elSel.id == el.id)) {
          this.regionalSelected.push(el);
        }
      });
    },
    isSelectedRegional(item) {
      return this.regionalSelected.some((el) => el.id === item.id);
    },
    toggleRegionalItem(item) {
      if (this.regionalSelected.some((el) => el.id === item.id)) {
        if (this.regionalSelected.length > 1) {
          this.removeRegional(item);
        }
      } else {
        this.regionalSelected.push(item);
      }
    },
    removeRegional(item) {
      if (this.regionalSelected.some((el) => el.id == item.id)) {
        let index = this.regionalSelected.map((e) => e.id).indexOf(item.id);
        if (index > -1) {
          this.regionalSelected.splice(index, 1);
        }
      }
    },
    selectAllAgency() {
      if (this.agencySelected.length <= 0) {
        return this.agenciesListItems.forEach((el) =>
          this.agencySelected.push(el)
        );
      }
      this.agenciesListItems.forEach((el) => {
        if (!this.agencySelected.some((elSel) => elSel.id == el.id)) {
          this.agencySelected.push(el);
        }
      });
    },
    isSelectedAgency(item) {
      return this.agencySelected.some((el) => el.id === item.id);
    },
    toggleItemAgency(item) {
      if (this.agencySelected.some((el) => el.id === item.id)) {
        if (this.agencySelected.length > 1) {
          this.removeAgency(item);
        }
      } else {
        this.agencySelected.push(item);
      }
    },
    removeAgency(item) {
      if (this.agencySelected.some((el) => el.id == item.id)) {
        let index = this.agencySelected.map((e) => e.id).indexOf(item.id);
        if (index > -1) {
          this.agencySelected.splice(index, 1);
        }
      }
    },
    backgroundCiColor(alert) {
      if (alert == "Alto") {
        return "var(--v-highAlert-base)";
      }
      if (alert == "Médio") {
        return "var(--v-mediumAlert-base)";
      }
      if (alert == "Baixo") {
        return "var(--v-lowAlert-base)";
      }
      if (alert == "Nulo") {
        return "var(--v-nullAlert-base)";
      }
    },
    backgroundCiColorBg(data) {
      if (data == "Alto") {
        return `background: #8765d43d; width: 75%;`;
      }
      if (data == "Médio") {
        return `background: #2b9da33d; width: 50%;`;
      }
      if (data == "Baixo") {
        return `background: #5dd2d83d; width: 25%;`;
      }
      if (data == "Nulo") {
        return;
      }
    },
    alertsWindColor(value) {
      if (value <= 40) {
        return "#9e9e9e";
      }
      if (value > 40 && value <= 55) {
        return "#e5c000";
      }
      if (value > 55 && value <= 70) {
        return "#df9f3e";
      }
      if (value > 70 && value <= 90) {
        return "#b4374b";
      }
      if (value > 90) {
        return "#873764";
      }
    },
    alertsPreciColor(value) {
      if (value >= 55) {
        return "#286e82";
      }
      if (value >= 38 && value < 55) {
        return "#4b879b";
      }
      if (value >= 20 && value < 38) {
        return "#73a5b4";
      }
      if (value >= 8.4 && value < 20) {
        return "#9bc3cd";
      }
      if (value < 8.4) {
        return "#9e9e9e";
      }
    },
    alertsPreciColorDiary(value) {
      if (value >= 155) {
        return "#286e82";
      }
      if (value >= 105 && value < 155) {
        return "#4b879b";
      }
      if (value >= 55 && value < 105) {
        return "#73a5b4";
      }
      if (value >= 40 && value < 55) {
        return "#9bc3cd";
      }
      if (value >= 15 && value < 40) {
        return "#bed7dc";
      }
      if (value < 15) {
        return "#9e9e9e";
      }
    },
    alertsTempColor(value) {
      if (value < 6) {
        return "#488DCA";
      }
      if (value >= 6 && value < 35) {
        return "#87C387";
      }
      if (value >= 35) {
        return "#A63220";
      }
    },
    createAlertBar(alerts, idContainer) {
      this.$nextTick(() => {
        let div_element = document.createElement("div");
        div_element.style.height = "8px";
        div_element.style.width = "100%";
        div_element.style.display = "flex";
        let hAlert_element = document.createElement("div");
        hAlert_element.style.borderRadius = "4px";
        hAlert_element.style.marginRight = "1px";
        hAlert_element.style.marginLeft = "1px";
        hAlert_element.style.backgroundColor = "var(--v-highAlert-base)";
        let mAlert_element = document.createElement("div");
        mAlert_element.style.borderRadius = "4px";
        mAlert_element.style.marginRight = "1px";
        mAlert_element.style.marginLeft = "1px";
        mAlert_element.style.backgroundColor = "var(--v-mediumAlert-base)";
        let lAlert_element = document.createElement("div");
        lAlert_element.style.borderRadius = "4px";
        lAlert_element.style.marginRight = "1px";
        lAlert_element.style.marginLeft = "1px";
        lAlert_element.style.backgroundColor = "var(--v-lowAlert-base)";
        let nAlert_element = document.createElement("div");
        nAlert_element.style.borderRadius = "4px";
        nAlert_element.style.marginRight = "1px";
        nAlert_element.style.marginLeft = "1px";
        nAlert_element.style.backgroundColor = "var(--v-nullAlert-base)";
        hAlert_element.classList.add("hAlert");
        mAlert_element.classList.add("mAlert");
        lAlert_element.classList.add("lAlert");
        nAlert_element.classList.add("nAlert");
        let hPercent = 0;
        let mPercent = 0;
        let lPercent = 0;
        let nPercent = 0;
        alerts.forEach((el) => {
          if (el.ciRange == "Alto") {
            hPercent = hPercent + 1;
          }
          if (el.ciRange == "Médio") {
            mPercent = mPercent + 1;
          }
          if (el.ciRange == "Baixo") {
            lPercent = lPercent + 1;
          }
          if (el.ciRange == "Nulo") {
            nPercent = nPercent + 1;
          }
        });
        hPercent = (hPercent / alerts.length) * 100;
        mPercent = (mPercent / alerts.length) * 100;
        lPercent = (lPercent / alerts.length) * 100;
        nPercent = (nPercent / alerts.length) * 100;
        hAlert_element.style.width = hPercent.toFixed(2) + "%";
        mAlert_element.style.width = mPercent.toFixed(2) + "%";
        lAlert_element.style.width = lPercent.toFixed(2) + "%";
        nAlert_element.style.width = nPercent.toFixed(2) + "%";
        div_element.appendChild(hAlert_element);
        div_element.appendChild(mAlert_element);
        div_element.appendChild(lAlert_element);
        div_element.appendChild(nAlert_element);
        let node = document.getElementById(idContainer);
        if (node) {
          node.innerHTML = "";
          node.appendChild(div_element);
        }
      });
    },
    fetchConsumerTableData() {
      this.$store.dispatch("fetchCountieForecastTableDetails", {
        locations: this.countiesSelectedItems,
        date: moment().add(1, "days").format("YYYY-MM-DD"),
      });
    },
    filterCountie(value) {
      if (!this.searchCountie) {
        return true;
      }
      return (
        value
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(this.searchCountie.toLowerCase()) ||
        value.toLowerCase().includes(this.searchCountie.toLowerCase())
      );
    },
    checkIfExistsExpandedChartAndClose(id) {
      let expandObject = {};
      for (const el in this.$refs.datatablePrediction.expansion) {
        expandObject[el] = false;
      }
      expandObject[id] = true;
      this.$refs.datatablePrediction.expansion = expandObject;
    },
    async onExpand({ item, value }) {
      const array = [];
      item.cityId = item.locationId;
      array.push(item);
      const payload = {
        locations: array,
      };
      if (value) {
        await this.$store.dispatch("fetchCountieForecastAll", payload);
        this.createCIAlertChart(item);
        this.controllerVariablesStart();
        this.checkIfExistsExpandedChartAndClose(item.id);
      }
    },
    createPeriods() {
      const dates = [
        moment().add(1, "hour").format("HH:00"),
        moment().add(2, "hour").format("HH:00"),
        moment().add(3, "hour").format("HH:00"),
        moment().format("DD/MM"),
        moment().add(1, "day").format("DD/MM"),
        moment().add(2, "day").format("DD/MM"),
        moment().add(3, "day").format("DD/MM"),
        moment().add(4, "day").format("DD/MM"),
      ];
      this.period = dates;
    },

    async createCIAlertChart(item) {
      this.createPeriods();
      this.createDataSerie();
      this.cIAlertChart = Highcharts.chart({
        chart: {
          renderTo: `chart-container-${item.locationId}`,
          backgroundColor: "var(--v-secondary-base)",
          height: "600px",
          marginTop: 20,
        },
        title: {
          text: "",
        },
        exporting: {
          enabled: false,
          filename: `Previsão de Consumidor Interrompido de ${item.locationName}`,
        },
        plotOptions: {
          column: {
            borderRadius: 5,
            pointPadding: 0.4,
            borderColor: "transparent",
            color: "#FFAD65",
          },
          series: {
            lineWidth: 1.5,
            marker: {
              radius: 2,
            },
          },
          spline: {
            color: "#545BC5",
          },
        },
        legend: {
          enabled: true,
          itemStyle: {
            color: "#FFFFFF",
          },
          itemHoverStyle: {
            color: "#979797",
          },
        },
        credits: {
          enabled: false,
        },
        xAxis: [
          {
            crosshair: true,
            rangeSelector: {
              enabled: false,
            },
            type: "category",
            categories: this.period,
            ordinal: false,
            height: "40%",
            labels: {
              style: {
                color: "#FFFFFF",
              },
            },
          },
          {
            crosshair: true,
            type: "category",
            categories: this.period,
            offset: 10,
            ordinal: false,
            labels: {
              style: {
                color: "#FFFFFF",
              },
            },
            plotLines: [
              {
                width: 2,
                color: "#FFFFFF",
                value: 2.5,
                zIndex: 2,
                label: {
                  text: "Previsão diária",
                  rotation: 0,
                  verticalAlign: "top",
                  textAlign: "left",
                  y: -3,
                  x: 25,
                  style: {
                    color: "#FFFFFF",
                    fontSize: "10",
                  },
                },
              },
              {
                width: 0,
                color: "#FFFFFF",
                value: 0,
                zIndex: 3,
                label: {
                  text: "Previsão para as próximas 3 horas",
                  textAlign: "left",
                  x: -30,
                  verticalAlign: "top",
                  y: -3,
                  rotation: 0,
                  style: {
                    color: "#FFFFFF",
                    fontSize: "10",
                  },
                },
              },
            ],
          },
        ],
        yAxis: [
          {
            title: {
              text: "Consumidores Interrompidos(CI)",
              style: {
                color: "#545BC5",
              },
            },
            labels: {
              format: "{value}K",
              style: {
                color: "#545BC5",
              },
            },
            height: "40%",
            lineWidth: 2,
            gridLineDashStyle: "longdash",
            gridLineWidth: 1,
            crosshairs: true,
            min: 0,
          },
          {
            title: {
              text: "Rajada máxima de vento(km/h) ",
              style: {
                color: "#267373",
              },
            },
            crosshairs: true,
            labels: {
              format: "{value}",
              style: {
                color: "#267373",
              },
            },
            top: "55%",
            height: "45%",
            offset: 0,
            lineWidth: 2,
            gridLineWidth: 0,
            reversed: false,
            min: 0,
            gridLineDashStyle: "longdash",
            plotLines: this.plotLines(),
          },
          {
            // 4 yAxis
            min: 0,
            title: {
              text: "Temperatura()",
              style: {
                color: "#87C387",
              },
            },
            top: "55%",
            height: "45%",
            opposite: true,
            reversed: false,
            offset: 0,
            gridLineDashStyle: "longdash",
            labels: {
              format: "{value}",
              style: {
                color: "#87C387",
              },
            },
          },
          {
            // 4 yAxis
            min: 0,
            title: {
              text: "Precipitação(mm)",
              style: {
                color: "#FFAD65",
              },
            },
            top: "55%",
            height: "45%",
            opposite: true,
            reversed: true,
            gridLineDashStyle: "longdash",
            offset: 0,
            labels: {
              format: "{value}",
              style: {
                color: "#FFAD65",
              },
            },
          },
        ],
        series: [
          //forecast series for three hours Consumidores
          {
            type: "spline",
            name: "Previsão de Consumidores Interrompidos (horária)",
            valueSuffix: "k",
            data: this.seriesCisHours,
            xAxis: 0,
          },
          //daily forecast series Consumidores
          {
            type: "spline",
            name: "Previsão de Consumidores Interrompidos (diária)",
            data: this.seriesCis,
            xAxis: 0,
            valueSuffix: "k",
          },
          {
            name: "Rajada de Vento (horária)",
            type: "spline",
            /*      data: [66, 48, 33], */
            data: this.seriesWindHours,
            valueSuffix: "km/h",
            yAxis: 1,
            dashStyle: "shortdot",
            color: "#267373",
            zIndex: 2,
            xAxis: 1,
          },
          //daily forecast series Rajada
          {
            type: "spline",
            ///data: [66, 48, 33],
            name: "Rajada de Vento (diária)",
            valueSuffix: "km/h",
            data: this.seriesWind,
            yAxis: 1,
            dashStyle: "shortdot",
            color: "#267373",
            zIndex: 2,
            xAxis: 1,
          },
          {
            type: "spline",
            name: "Temperatura Máxima (diária)",
            data: this.seriesTempMax,
            yAxis: 2,
            dashStyle: "Solid",
            color: "#A63220",
            valueSuffix: "°C",
            zIndex: 3,
            xAxis: 1,
          },
          {
            type: "spline",

            name: "Temperatura mínima (diária)",
            valueSuffix: "°C",
            data: this.seriesTempMin,
            yAxis: 2,
            dashStyle: "Solid",
            color: " #488DCA",
            xAxis: 1,
          },
          {
            type: "spline",
            name: "Temperatura média (diária)",
            valueSuffix: "°C",
            data: this.seriesTemp,
            yAxis: 2,
            dashStyle: "Solid",
            color: "#87C387",
            zIndex: 3,
            xAxis: 1,
          },
          {
            type: "column",
            name: "Precipitação (horária)",
            valueSuffix: "mm",
            yAxis: 3,
            data: this.seriesPrecIntencityHours,
            zIndex: 1,
            xAxis: 1,
          },
          {
            type: "spline",
            name: "Temperatura média (horária)",
            data: this.seriesTempHours,
            yAxis: 2,
            dashStyle: "Solid",
            color: "#87C387",
            valueSuffix: "°C",
            zIndex: 3,
            xAxis: 1,
          },
          {
            type: "column",
            name: "Precipitação (diária)",
            valueSuffix: "mm",
            yAxis: 3,
            data: this.seriesPrecIntencity,

            zIndex: 1,
          },
        ],
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 600,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                  navigation: {
                    enabled: false,
                  },
                },
              },
            },
          ],
        },
        tooltip: {
          //enabled: true,
          shared: true,
          split: true,
          //crosshairs: true,
          useHTML: true,
          xDateFormat: "%A, %b %d",
          pointFormatter: function () {
            const value = this.series.userOptions.valueDecimals
              ? Number(this.y).toFixed(this.series.userOptions.valueDecimals)
              : this.y;
            return (
              '<strong style="color:' +
              this.series.color +
              '">' +
              this.series.name +
              "</strong>: <strong>" +
              value +
              " " +
              this.series.userOptions.valueSuffix +
              "<strong/>"
            );
          },
        },
      });
    },

    createDataSerie() {
      this.createPeriods();
      this.seriesCis = [];
      this.seriesPrecIntencity = [];
      this.seriesWind = [];
      this.seriesTemp = [];
      this.seriesTempMax = [];
      this.seriesTempMin = [];
      this.seriesCisHours = [];
      this.seriesPrecIntencityHours = [];
      this.seriesWindHours = [];
      this.seriesTempHours = [];
      this.seriesTempMaxHours = [];
      this.seriesTempMinHours = [];
      let i = 3;
      this.countiesForecastDataAll.forEach((el) => {
        if (typeof el.forecastValues.windGust != "undefined") {
          const windGust = Number(el.forecastValues.windGust.toFixed(1));
          this.seriesWind.push([this.period[i], windGust]);
        }
        if (typeof el.forecastValues.precIntensity != "undefined") {
          this.seriesPrecIntencity.push([
            this.period[i],
            el.forecastValues.precIntensity,
          ]);
        }
        if (typeof el.forecastValues.temp != "undefined") {
          this.seriesTemp.push([this.period[i], el.forecastValues.temp]);
        }
        if (typeof el.forecastValues.tempMax != "undefined") {
          this.seriesTempMax.push([this.period[i], el.forecastValues.tempMax]);
        }
        if (typeof el.forecastValues.tempMin != "undefined") {
          this.seriesTempMin.push([this.period[i], el.forecastValues.tempMin]);
        }
        if (typeof el.cistart != "undefined") {
          this.seriesCis.push([
            this.period[i],
            parseInt(el.cistart.replace(".", "")),
          ]);
        }
        if (typeof el.cistart == "undefined") {
          this.seriesCis.push([this.period[i], 0]);
        }
        if (typeof el.precIntensity == "undefined") {
          this.seriesPrecIntencity.push([this.period[i], 0]);
        }
        i++;
      });
      i = 0;
      this.countiesForecastDataHourlyAll.forEach((el) => {
        if (typeof el.forecastValues.windGust != "undefined") {
          const windGust = Number(el.forecastValues.windGust.toFixed(1));
          this.seriesWindHours.push([this.period[i], windGust]);
        }
        if (typeof el.forecastValues.precIntensity != "undefined") {
          this.seriesPrecIntencityHours.push([
            this.period[i],
            el.forecastValues.precIntensity,
          ]);
        }
        if (typeof el.forecastValues.tempMax != "undefined") {
          this.seriesTempMaxHours.push([
            this.period[i],
            el.forecastValues.tempMax,
          ]);
        }
        if (typeof el.forecastValues.temp != "undefined") {
          this.seriesTempHours.push([this.period[i], el.forecastValues.temp]);
        }
        if (typeof el.forecastValues.tempMin != "undefined") {
          this.seriesTempMinHours.push([
            this.period[i],
            el.forecastValues.tempMin,
          ]);
        }
        if (typeof el.cistart != "undefined") {
          this.seriesCisHours.push(parseInt(el.cistart.replace(".", "")));
        }
        if (typeof el.cistart == "undefined") {
          this.seriesCisHours.push([this.period[i], 0]);
        }
        if (typeof el.precIntensity == "undefined") {
          this.seriesPrecIntencityHours.push([this.period[i], 0]);
        }
        i++;
      });
    },
    controllerVariablesStart() {
      if (
        this.changeBackgroundColorWind == true &&
        this.changeBackgroundColorRain == true
      ) {
        this.cIAlertChart.series[4].hide();
        this.cIAlertChart.series[5].hide();
        this.cIAlertChart.series[6].hide();
        this.cIAlertChart.series[8].hide();
        this.cIAlertChart.series[3].update({
          showInLegend: true,
        });
        this.cIAlertChart.series[4].update({
          showInLegend: false,
        });
        this.cIAlertChart.series[5].update({
          showInLegend: false,
        });
        this.cIAlertChart.series[6].update({
          showInLegend: false,
        });
        this.cIAlertChart.series[8].update({
          showInLegend: false,
        });

        this.cIAlertChart.yAxis[1].update({
          plotLines: false,
        });

        this.cIAlertChart.yAxis[2].update({
          title: false,
        });
        this.checkVariveisOne();
        return;
      }
      if (
        this.changeBackgroundColorWind == true &&
        this.changeBackgroundColorTemperature == true
      ) {
        this.cIAlertChart.series[7].hide();
        this.cIAlertChart.series[9].hide();
        this.cIAlertChart.series[7].update({
          showInLegend: false,
        });
        this.cIAlertChart.series[9].update({
          showInLegend: false,
        });
        this.cIAlertChart.yAxis[3].update({
          title: false,
        });
        this.checkVariveisOne();
        return;
      }
      if (
        this.changeBackgroundColorRain == true &&
        this.changeBackgroundColorTemperature == true
      ) {
        this.cIAlertChart.series[2].hide();
        this.cIAlertChart.series[3].hide();

        this.cIAlertChart.series[2].update({
          showInLegend: false,
        });
        this.cIAlertChart.series[3].update({
          showInLegend: false,
        });

        this.cIAlertChart.yAxis[1].update({
          title: false,
        });
        this.checkVariveisOne();
        return;
      }
      if (this.changeBackgroundColorRain == true) {
        this.cIAlertChart.series[2].hide();
        this.cIAlertChart.series[3].hide();

        this.cIAlertChart.series[2].update({
          showInLegend: false,
        });
        this.cIAlertChart.series[3].update({
          showInLegend: false,
        });
        this.cIAlertChart.yAxis[1].update({
          title: false,
        });
        this.cIAlertChart.series[4].hide();
        this.cIAlertChart.series[5].hide();
        this.cIAlertChart.series[6].hide();
        this.cIAlertChart.series[8].hide();
        this.cIAlertChart.series[3].update({
          showInLegend: false,
        });
        this.cIAlertChart.series[4].update({
          showInLegend: false,
        });
        this.cIAlertChart.series[5].update({
          showInLegend: false,
        });
        this.cIAlertChart.series[6].update({
          showInLegend: false,
        });
        this.cIAlertChart.series[8].update({
          showInLegend: false,
        });
        this.cIAlertChart.yAxis[1].update({
          plotLines: false,
        });
        this.cIAlertChart.yAxis[2].update({
          title: false,
        });
        this.checkVariveisOne();
        return;
      }
      if (this.changeBackgroundColorWind == true) {
        this.cIAlertChart.series[7].hide();
        this.cIAlertChart.series[9].hide();
        this.cIAlertChart.series[7].update({
          showInLegend: false,
        });
        this.cIAlertChart.series[9].update({
          showInLegend: false,
        });
        this.cIAlertChart.yAxis[3].update({
          title: false,
        });
        this.cIAlertChart.series[4].hide();
        this.cIAlertChart.series[5].hide();
        this.cIAlertChart.series[6].hide();
        this.cIAlertChart.series[8].hide();
        this.cIAlertChart.series[3].update({
          showInLegend: true,
        });
        this.cIAlertChart.series[4].update({
          showInLegend: false,
        });
        this.cIAlertChart.series[5].update({
          showInLegend: false,
        });
        this.cIAlertChart.series[6].update({
          showInLegend: false,
        });

        this.cIAlertChart.series[8].update({
          showInLegend: false,
        });
        this.cIAlertChart.yAxis[1].update({
          plotLines: false,
        });
        this.cIAlertChart.yAxis[2].update({
          title: false,
        });
        this.checkVariveisOne();
        return;
      }
      if (this.changeBackgroundColorTemperature == true) {
        this.cIAlertChart.series[7].hide();
        this.cIAlertChart.series[9].hide();
        this.cIAlertChart.series[7].update({
          showInLegend: false,
        });
        this.cIAlertChart.series[9].update({
          showInLegend: false,
        });
        this.cIAlertChart.yAxis[3].update({
          title: false,
        });
        this.cIAlertChart.series[2].hide();
        this.cIAlertChart.series[3].hide();
        this.cIAlertChart.series[2].update({
          showInLegend: false,
        });
        this.cIAlertChart.series[3].update({
          showInLegend: false,
        });
        this.cIAlertChart.yAxis[1].update({
          title: false,
        });
        this.checkVariveisOne();
        return;
      }
    },

    toggleWind() {
      if (
        this.changeBackgroundColorTemperature == false &&
        this.changeBackgroundColorRain == false
      ) {
        return;
      }
      if (
        this.changeBackgroundColorTemperature == true &&
        this.changeBackgroundColorRain == true
      ) {
        this.toggleTemperature();
      }
      this.changeBackgroundColorWind = !this.changeBackgroundColorWind;
      if (
        this.changeBackgroundColorTemperature == true ||
        this.changeBackgroundColorRain == true
      ) {
        this.cIAlertChart.yAxis[1].update({
          plotLines: false,
        });
      }
      this.checkVariveisOne();
      if (this.changeBackgroundColorWind == true) {
        this.cIAlertChart.series[2].show();
        this.cIAlertChart.series[3].show();
        this.cIAlertChart.series[2].update({
          showInLegend: true,
        });
        this.cIAlertChart.series[3].update({
          showInLegend: true,
        });

        this.cIAlertChart.yAxis[1].update({
          title: {
            text: "Rajada máxima de vento (km/h)",
            style: {
              color: "#267373",
            },
          },
        });
        return;
      }
      this.cIAlertChart.series[2].hide();
      this.cIAlertChart.series[3].hide();
      this.cIAlertChart.series[2].update({
        showInLegend: false,
      });
      this.cIAlertChart.series[3].update({
        showInLegend: false,
      });
      this.cIAlertChart.yAxis[1].update({
        title: false,
      });
    },

    toggleRain() {
      if (
        this.changeBackgroundColorTemperature == false &&
        this.changeBackgroundColorWind == false
      ) {
        return;
      }
      if (
        this.changeBackgroundColorWind == true &&
        this.changeBackgroundColorTemperature == true
      ) {
        this.toggleTemperature();
      }
      this.checkVariveisOne();
      if (this.changeBackgroundColorWind == true) {
        this.cIAlertChart.yAxis[1].update({
          plotLines: false,
        });
      }
      if (this.changeBackgroundColorTemperature == true) {
        this.cIAlertChart.yAxis[3].update({
          opposite: false,
        });
        this.cIAlertChart.yAxis[2].update({
          title: {
            text: "Temperatura(°C)",
            style: {
              color: "#87C387",
            },
          },
        });
      }
      this.changeBackgroundColorRain = !this.changeBackgroundColorRain;
      this.checkVariveisOne();
      if (this.changeBackgroundColorRain == true) {
        this.cIAlertChart.series[7].show();
        this.cIAlertChart.series[9].show();
        this.cIAlertChart.series[7].update({
          showInLegend: true,
        });

        this.cIAlertChart.series[9].update({
          showInLegend: true,
        });
        this.cIAlertChart.yAxis[3].update({
          title: {
            text: "Precipitação(mm)",
            style: {
              color: "#FFAD65",
            },
          },
          opposite: this.changeBackgroundColorTemperature ? false : true,
        });
        return;
      }
      this.cIAlertChart.series[7].hide();
      this.cIAlertChart.series[9].hide();
      this.cIAlertChart.series[7].update({
        showInLegend: false,
      });
      this.cIAlertChart.series[9].update({
        showInLegend: false,
      });
      this.cIAlertChart.yAxis[3].update({
        title: false,
      });
      this.checkVariveisOne();
    },

    toggleTemperature() {
      if (
        this.changeBackgroundColorRain == false &&
        this.changeBackgroundColorWind == false
      ) {
        return;
      }
      if (
        this.changeBackgroundColorWind == true &&
        this.changeBackgroundColorRain == true
      ) {
        this.toggleRain();
      }
      if (this.changeBackgroundColorWind == true) {
        this.cIAlertChart.yAxis[1].update({
          plotLines: false,
        });
      }
      if (this.changeBackgroundColorRain == true) {
        this.cIAlertChart.yAxis[3].update({
          opposite: true,
        });
      }
      this.changeBackgroundColorTemperature =
        !this.changeBackgroundColorTemperature;
      this.checkVariveisOne();
      if (this.changeBackgroundColorTemperature == true) {
        this.cIAlertChart.series[4].show();
        this.cIAlertChart.series[5].show();
        this.cIAlertChart.series[6].show();
        this.cIAlertChart.series[8].show();
        this.cIAlertChart.series[4].update({
          showInLegend: true,
        });
        this.cIAlertChart.series[5].update({
          showInLegend: true,
        });
        this.cIAlertChart.series[6].update({
          showInLegend: true,
        });

        this.cIAlertChart.series[8].update({
          showInLegend: true,
        });
        this.cIAlertChart.yAxis[2].update({
          title: {
            text: "Temperatura(°C)",
            style: {
              color: "#87C387",
            },
          },
        });
        return;
      }
      this.cIAlertChart.series[4].hide();
      this.cIAlertChart.series[5].hide();
      this.cIAlertChart.series[6].hide();
      this.cIAlertChart.series[8].hide();
      this.cIAlertChart.series[4].update({
        showInLegend: false,
      });
      this.cIAlertChart.series[5].update({
        showInLegend: false,
      });
      this.cIAlertChart.series[6].update({
        showInLegend: false,
      });
      this.cIAlertChart.series[8].update({
        showInLegend: false,
      });
      this.cIAlertChart.yAxis[2].update({
        title: false,
      });
    },

    plotLines() {
      const plotLines = [
        {
          value: 0,
          width: 1,
          dashStyle: "longdash",

          label: {
            text: "Fraco 0 a 40 Km/h",
            align: "start",
            style: {
              color: "#F2F2F2",
            },
          },
        },
        {
          color: "#E6C000",
          value: 40,
          dashStyle: "longdash",
          width: 1,
          label: {
            text: " Moderado 40 a 55 Km/h",
            style: {
              color: "#E6C000",
            },
          },
        },
        {
          color: "#DF9F3E",
          value: 55,
          dashStyle: "longdash",
          width: 1,
          label: {
            text: "Forte 55 a 70 km/h",

            style: {
              color: "#DF9F3E",
              verticalAlign: "",
              textAlign: "left",
            },
          },
        },
        {
          color: "#B4374B",
          value: 70,
          dashStyle: "longdash",
          width: 1,
          label: {
            text: "Intenso 70 a 90 km/h",
            style: {
              color: "#B4374B",
              verticalAlign: "",
              textAlign: "left",
            },
          },
        },
        {
          color: "#873764",
          value: 90,
          dashStyle: "longdash",
          width: 1,
          label: {
            text: "Extremo Acima de 90 km/h",
            style: {
              color: "#873764",
              verticalAlign: "",
              textAlign: "left",
            },
          },
        },
      ];
      return plotLines;
    },

    checkVariveisOne() {
      if (
        this.changeBackgroundColorWind == true &&
        this.changeBackgroundColorTemperature == false &&
        this.changeBackgroundColorRain == false
      ) {
        this.cIAlertChart.yAxis[1].update({
          plotLines: this.plotLines(),
        });

        return;
      }
      if (
        this.changeBackgroundColorWind == false &&
        this.changeBackgroundColorTemperature == false &&
        this.changeBackgroundColorRain == true
      ) {
        this.cIAlertChart.yAxis[3].update({
          title: {
            text: "Precipitação(mm)",
            style: {
              color: "#FFAD65",
            },
          },
          opposite: false,
        });
        return;
      }
      if (
        this.changeBackgroundColorWind == false &&
        this.changeBackgroundColorTemperature == true &&
        this.changeBackgroundColorRain == false
      ) {
        this.cIAlertChart.yAxis[2].update({
          opposite: false,
        });
      }
      if (
        this.changeBackgroundColorRain == true &&
        this.changeBackgroundColorTemperature == true &&
        this.changeBackgroundColorWind == false
      ) {
        this.cIAlertChart.yAxis[2].update({
          opposite: true,
        });
        this.cIAlertChart.yAxis[3].update({
          opposite: false,
        });
        return;
      }
      if (
        this.changeBackgroundColorRain == false &&
        this.changeBackgroundColorTemperature == true &&
        this.changeBackgroundColorWind == true
      ) {
        this.cIAlertChart.yAxis[2].update({
          opposite: true,
        });
        return;
      }
      if (
        this.changeBackgroundColorRain == true &&
        this.changeBackgroundColorTemperature == false &&
        this.changeBackgroundColorWind == true
      ) {
        this.cIAlertChart.yAxis[3].update({
          opposite: true,
        });
        this.cIAlertChart.series[4].hide();
        this.cIAlertChart.series[5].hide();
        this.cIAlertChart.series[6].hide();
        this.cIAlertChart.series[8].hide();
        this.cIAlertChart.series[4].update({
          showInLegend: false,
        });
        this.cIAlertChart.series[5].update({
          showInLegend: false,
        });
        this.cIAlertChart.series[6].update({
          showInLegend: false,
        });

        this.cIAlertChart.series[8].update({
          showInLegend: false,
        });
        this.cIAlertChart.yAxis[2].update({
          title: false,
        });
        return;
      }
    },
    closeExpandAll() {
      if (this.cIAlertChart) {
        //this.cIAlertChart.destroy();
        let expandObject = {};
        for (const item of this.countiesForecastTableDetails) {
          expandObject[item.id] = false;
        }
        this.$refs.datatablePrediction.expansion = expandObject;
      }
    },
    closeForecastTableDialog() {
      this.closeExpandAll();
      this.$emit("closeForecastTableDialog", false);
    },
    fullscreenChart() {
      this.cIAlertChart.fullscreen.toggle();
    },
    exportChart(typeFile) {
      this.cIAlertChart.exportChart({ type: typeFile });
    },
    exportCSV() {
      this.cIAlertChart.downloadCSV();
    },
    exportXLS() {
      this.cIAlertChart.downloadXLS();
    },
    printChart() {
      this.cIAlertChart.print();
    },
  },
};
</script>

<style scoped lang="scss">
#forecast-counties-root {
  background-color: var(--v-background-darken1);
}
.forecast-counties-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  color: var(--v-primary-base);
}
.forecast-counties-subtitle {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
}
.forecast-counties-title-chip {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.4px;
  background-color: var(--v-secondary-base);
  color: var(--v-primary-base);
  border-radius: 4px;
}

.forecast-new-page-icon-text {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-accent-base);
}

label {
  order: -1;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
}

.text-field {
  border-radius: 8px;
}

.v-input:focus-within + label {
  color: var(--v-accent-lighten1) !important;
}

.form-input-group {
  display: flex;
  width: 400px;
  min-width: 100px;
  padding-right: 10px;
  flex-direction: column;
}

.btn-form {
  text-transform: none;
  border-radius: 8px;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  background-color: var(--v-secondary-base);
}

.shutdown-risk-chip {
  background-color: var(--v-secondary-lighten1);
  color: var(--v-primary-base);
  border-radius: 4px;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  height: 24px;
  display: flex;
  align-items: center;
  padding-left: 4px;
  padding-right: 4px;
}

.prediction-data-table {
  border-radius: 8px;
}

::v-deep .v-pagination__navigation {
  background-color: var(--v-background-darken1) !important;
  border: 1px solid rgba(255, 255, 255, 0.12);
}
::v-deep .v-pagination__item {
  background-color: var(--v-background-darken1) !important;
  border: 1px solid rgba(255, 255, 255, 0.12);
}

#chart-container {
  height: 400px;
}

.dropdown-item-style {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}

.title-row {
  background-color: var(--v-secondary-lighten2);
  color: var(--v-primary-base);
}

.table-row {
  background-color: var(--v-secondary-lighten1);
}

.v-data-table {
  border: 1px solid rgba(255, 255, 255, 0.12);
}

::v-deep .td-header-agency {
  background-color: var(--v-secondary-base);
}

.header-agency-text {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: var(--v-primary-base);
}

.header-agency-counties {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.5px;
  color: var(--v-primary-base);
}

.header-agency-counties-name {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
}

.ci-range {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--primary-base);
}

.ci-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--primary-base);
}

::v-deep tbody {
  tr {
    background-color: var(--v-secondary-lighten1) !important;
  }
  tr:hover {
    background-color: var(--v-secondary-lighten1) !important;
  }
}

.table-footer {
  background-color: var(--v-secondary-base);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.pagination-counter {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-primary-darken2);
}

::v-deep .v-data-table__wrapper {
  background-color: var(--v-secondary-base) !important;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.countie-column {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
}

.countie-sig {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  letter-spacing: 0.4px;
  color: var(--v-primary-base);
  background-color: var(--v-secondary-base);
  border-radius: 4px;
}

::v-deep
  .theme--dark.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  background-color: var(--v-secondary-base);
}

::v-deep #predictionDataTable .v-data-table__wrapper::-webkit-scrollbar {
  width: 4px;
  background-color: var(--v-secondary-base);
}

/* Handle */
::v-deep #predictionDataTable .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: var(--v-accent-base);
  border-radius: 2px;
}

/* Handle on hover */
::v-deep
  #predictionDataTable
  .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: var(--v-accent-lighten1);
}

.select-pagination {
  max-width: 48px;
}

.btn-style {
  border-radius: 8px;
  border: 1px solid #f2f2f8;
}
</style>
